import Cookies from 'js-cookie'

import store from '../store'

const TokenKey = 'vue_admin_template_token_visualization'

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}


export function getToken() {
    return Cookies.get(TokenKey)
}

export function getTokenBykey(key) {
    return Cookies.get(key)
}

export function removeTokenBykey(key) {
    return Cookies.remove(key)
}

export function setTokenBykey(key,token) {
    return Cookies.set(key, token)
}


export function getStaffCode() {
    let staffDTO = JSON.parse(getToken());
    if(isChain(staffDTO)){
        return store.state.activeStaffCode;
    }
    return staffDTO.staffCode;
}
function isChain(staffDTO){
    if(staffDTO.institutionDTO != null){
        if(staffDTO.institutionDTO.isChain == 1 && staffDTO.institutionDTO.chainType == "parent"){
            if(store.state.activeStaffCode != null){
                // console.log(store.state.activeInstitutionCode);
                return true
            }
        }
    }
}
export function getInstitutionCode() {
    let staffDTO = JSON.parse(getToken());
    if(isChain(staffDTO)){
        return store.state.activeInstitutionCode;
    }

    return staffDTO.institutionCode;
}

//根据域名获取机构名
export function getInsNameByDomainName() {
    var name='乐庭'
    let host=window.location.host
    // if(host=='192.168.1.147:8080'){
    if(host=='yian.visual.ltylao.com'){
        name = '来凤颐安'
    }
    return name;
}


